import { Button, Dialog, DialogContent, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";

import { BoxFC } from "components/BoxCustom";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { jobOrderApiNm } from "constants/jobOrderConstant";
import dayjs from "dayjs";
import { CloudDownloadRounded } from "resource/muiImport";
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

const JobOrderImageDialog = ({ dialogOpen, setDialogOpen, selectedId }) => {

  const { ax} = useContext(GlobalStateContext)

  const [jobOrdFiles, setJobOrdFiles] = useState([])
  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    if (dialogOpen) {
      ax.post(jobOrderApiNm.getJobOrderFileTable, { JobOrdId: selectedId }).then(value => {
        if (value.data && value.data.length > 0) {
          const files = value.data[0].Files
          setJobOrdFiles(files)
        }
      })
    } else {
      setJobOrdFiles([])
    }
  }, [ax, selectedId, dialogOpen])

  const handleDownloadAll = async () => {
    if (!jobOrdFiles?.length || downloading) return
    setDownloading(true)
    try {
      const zip = new JSZip()
      const folder = zip.folder(`job-order-${selectedId}`)
      for (const file of jobOrdFiles) {
        const src = `/file/job-order/${selectedId}/${file.FileNm}`
        try {
          const res = await fetch(src, { credentials: 'include' })
          if (!res.ok) throw new Error(`HTTP ${res.status}`)
          const buf = await res.arrayBuffer()
          folder.file(file.FileNm, buf, { binary: true })
        } catch (e) {
          // continue on error for individual files
          // eslint-disable-next-line no-console
          console.error('Failed to fetch file for zip', file.FileNm, e)
        }
      }
      const zipBlob = await zip.generateAsync({ type: 'blob', compression: 'STORE' })
      saveAs(zipBlob, `job-order-${selectedId}.zip`)
    } finally {
      setDownloading(false)
    }
  }
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl' >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`รูปภาพ (${jobOrdFiles.length} รูป)`}
        onDeleteClick={null}
      >
        <Button variant="contained" color="secondary" sx={{ml: 1}} onClick={handleDownloadAll} disabled={downloading || jobOrdFiles.length === 0}>
          <CloudDownloadRounded sx={{mr: 1}}/>
          {downloading ? 'Downloading…' : 'Download All'}
        </Button>
        </DialogHeader>
      <DialogContent>
        <BoxFC mt={1} sx={{ gap: 0 }}>
          
          <ImageList cols={2} rowHeight={600} sx={{ width: "100%", maxHeight: 630 }}>
            {jobOrdFiles.map(file => {
              
              const src = `/file/job-order/${selectedId}/${file.FileNm}`
              const linkUrl = src.replaceAll("/", "~")
             
              return (
                <ImageListItem key={file.FileNm} sx={{ position: "relative" }} >
                  <img alt={file.Label} src={src} loading="lazy" onClick={() => window.open(`/image/${linkUrl}`)} style={{ height: 600 }} />
                  
                  <ImageListItemBar
                    sx={{ px: 6 }}
                    title={`${file.Label}`}
                    subtitle={
                      <BoxFC sx={{ gap: 0.5 }}>
                        <span>by: {file.DrvNNm} {dayjs(file.AddTm).format("DD/MM/YYYY HH:mm")}</span>
                      </BoxFC>
                    }
                  />
                </ImageListItem>
              )
            })}
          </ImageList>
          
        </BoxFC>
      </DialogContent>
      <DialogFooter okText=""
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(JobOrderImageDialog)